<script setup lang="ts">
// @ts-expect-error raison: lib externe mal typée
import { defineProps, ref } from 'vue';
import { useMarketCartStore } from '@/stores/cart.store';
import { formatAmount } from '@/utils/formatters';
import { showAlert } from '@/utils/swal';
import ConfirmationModal from '@/components/ConfirmationModal.vue';
import { useRouter } from 'vue-router';

const router = useRouter();
const cart = useMarketCartStore();
const props = defineProps({
    layout: { type: String, default: 'none' },
    hideButton: { type: Boolean, default: false },
});
const confirmationModalRef = ref<InstanceType<typeof ConfirmationModal> | null>(null);
const loadingEmptyCart = ref(false);
const errorMessageEmptyCart = ref('');
const loadingSubmitCart = ref(false);

async function doEmptyCart() {
    const confirm = await confirmationModalRef.value?.open("Panier", "Voulez-vous vraiment vider le panier ?");
    if (confirm) {
        loadingEmptyCart.value = true;
        try {
            cart.clearCart();
        } catch(error: any) {
            errorMessageEmptyCart.value = error.message || 'Une erreur est survenue lors de la requete au serveur. Veuillez réessayer.';
            await showAlert.error(errorMessageEmptyCart.value);
        } finally {
            loadingEmptyCart.value = false;
        }
    }
}

async function doSubmitCart() {
    loadingSubmitCart.value = true;
    await router.push(props.layout == 'frontoffice' ? '/front/market/checkout' : '/market/checkout');
}

</script>
<template>
    <div class="widget s20 px-6 py-7">
        <h3 class="secondary-font text-grey-700 mb-5">Votre commande</h3>

        <h5 class="s10 secondary-font text-grey-700 mb-4">Sous-total</h5>
        <h5 class="s10 secondary-font text-grey-700 mb-4 text-right">{{ formatAmount(cart.getSousTotal) }} F</h5>
        <h5 class="s10 secondary-font text-red mb-4">Réduction</h5>
        <h5 class="s10 secondary-font text-red mb-4 text-right">-{{ formatAmount(cart.getTotalPromotion) }} F</h5>
        <h5 class="s10 secondary-font text-grey-700 mb-4">TOTAL</h5>
        <h5 class="s10 secondary-font text-grey-700 mb-4 text-right">{{ formatAmount(cart.getTotal) }} F</h5>

        <div class="clear-both h-0"></div>
        <div class="s20 flex-center bg-color rounded-20 px-5 pt-4 pb-3">
            <h5 class="s10 secondary-font text-primary-color">Payer par mois</h5>
            <h5 class="s10 secondary-font text-primary-color text-right">{{ formatAmount(cart.getTotalEcheances) }} F</h5>
        </div>
        <div class="clear-both h-20"></div>
        <div v-if="!hideButton">
            <button class="btn-ultra lg w-100" :class="{'loading': loadingSubmitCart}" @click="doSubmitCart"><!-- loading sm tips color2 light white white2 success info warning danger-->
                <div class="btn-show">
                    <span>&nbsp;Valider mon panier</span>
                </div>
                <div class="btn-loading">
                    <div class="loader-dots"></div>
                </div>
            </button>
            <button class="btn-ultra danger lg w-100" @click="doEmptyCart" style="margin-top: 20px;"><!-- loading sm tips color2 light white white2 success info warning danger-->
                <div class="btn-show">
                    <span>&nbsp;Vider mon panier</span>
                </div>
                <div class="btn-loading">
                    <div class="loader-dots"></div>
                </div>
            </button>
        </div>
        <confirmation-modal ref="confirmationModalRef"></confirmation-modal>
    </div>
</template>